import MuiCircularProgress, {
  CircularProgressProps as MuiCircularProgressProps,
} from '@mui/material/CircularProgress';

interface CircularProgressProps extends MuiCircularProgressProps {
  size?: 'small' | 'medium' | 'large' | 'giant';
}

export const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 'small',
  ...props
}) => {
  const sizes = {
    small: 20,
    medium: 40,
    large: 60,
    giant: 120,
  };

  return <MuiCircularProgress size={sizes[size]} {...props} />;
};
